'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var typeOf = {};

exports.__exports = typeOf;
